import { PriceSettings } from '@/types/price-settings'
import { CellSettings, TableCell } from '@/types/table'

import productPriceSettingDistCell from '@/components/root-components/product-price-setting/cells/dist-cell.vue';
import productPriceSettingDiscountCell from '@/components/root-components/product-price-setting/cells/discount-cell.vue';

import productPriceSettingMaxVolumeCell from '@/components/root-components/product-price-setting/cells/max-volume-cell.vue'
import productPriceSettingMinVolumeCell from '@/components/root-components/product-price-setting/cells/min-volume-cell.vue'
import productPriceSettingMaxTermCell from '@/components/root-components/product-price-setting/cells/max-term-cell.vue'
import productPriceSettingMinTermCell from '@/components/root-components/product-price-setting/cells/min-term-cell.vue'
import productPriceSettingPriceCell from '@/components/root-components/product-price-setting/cells/price-cell.vue'

export const getChildren = (id: number, list: PriceSettings[]): PriceSettings[] => {
    return list.filter((item) => item.Parents.some((parentId) => parentId === id));
}

export const getParents = (parentsId: number[], list: PriceSettings[]): PriceSettings[] => {
    return list.filter((item) => parentsId.includes(item.Id)).reverse();
}

export const changeParentsState = (parentItem: PriceSettings, children: PriceSettings[]) => {
    if(children.some((elem) => elem.IsChecked) && !children.every((elem) => elem.IsChecked)) {
        //отмечена лишь часть
        parentItem.AnyChildChecked = true;
        parentItem.IsChecked = false;
        
    }
    else if(children.every((elem) => elem.IsChecked)) {
        //все дочерние элементы отмечены
        parentItem.AnyChildChecked = false;
        parentItem.IsChecked = true;
    }
    else {
        //ни один не отмечен
        parentItem.AnyChildChecked = false;
        parentItem.IsChecked = false;
    }
}

export const setPriceSettings = (item: PriceSettings, rootList: PriceSettings[]) => {
    //добавляем признак видимости и наличия дочерних элементов
    item.Hidden = item.Parents.length > 0;
    item.HasChilds = rootList.some((rootItem) => rootItem.Parents.includes(item.Id));

    //по умолчанию элементы закрыты
    item.Expanded = false;

    const children = getChildren(item.Id, rootList);

    if(children.length > 0) {
        changeParentsState(item, children)
    }
    
    return item;
}

export const setDeliveryRowBySearch = (rows: PriceSettings[], keyword: string) => {
    const list = rows.filter((item, index) => {
        if(!keyword && index == 0) {
            item.Hidden = false;
            item.Expanded = false;
            return
        }

        item.Hidden = true;
        item.Expanded = false;
        
        if(item.Name.toLocaleLowerCase().includes(keyword.toLocaleLowerCase()) && keyword) {
            item.Hidden = false;
            return true
        }
    })

    if(keyword) {
        const parentsIds = list?.filter((item) => !item.Hidden).map((item) => item.Parents).flat();

        rows.forEach((item) => {
            if(parentsIds.includes(item.Id)) {
                item.Hidden = false;
                item.Expanded = true;
            }
        })
    }
}

export const setRowExpandedState = (rows: PriceSettings[], row: PriceSettings) => {
    
    //закрытие или нет
    const close = row.Expanded;
    row.Expanded = !row.Expanded;

    if(rows) {
        rows.forEach((item) => {
            if(close) {
                if(item.Parents.some((parent: number) => parent === row.Id)) {
                    item.Hidden = true
                    item.Expanded = false                          
                }
            } else {
                //item.Parents[0] - id ближайшего родителя
                if(item.Parents[0] === row.Id) {
                    item.Hidden = false;                 
                }
            }
            return item
        })
    }
}

export const setRowCheckingState = (rows: PriceSettings[], row: PriceSettings, inputValue: boolean) => {
    let children: PriceSettings[] = [];
    let parents: PriceSettings[] = [];

    if(rows) {
        
        //получаем потомков
        children = getChildren(row.Id, rows);
        
        if(children && children.length > 0) {
            //выставляем значение хотя-бы одного выбранного 
            //далее меняем состояние дочерним элементам
            row.AnyChildChecked = inputValue;
            children.forEach((item) => {
                if(item.HasChilds)
                { 
                    item.AnyChildChecked=inputValue
                }
                item.IsChecked = inputValue
            })
        }

        if(row.Parents) {
            //получаем родителей
            parents = getParents(row.Parents, rows);

            if(parents && parents.length > 0)  {

                parents.forEach((parentItem: PriceSettings) => {
                    if(rows) {
                        const parentsChildren = getChildren(parentItem.Id, rows);
                        //меняем состояние каждому родителяю в зависимости от состояния потомков
                        changeParentsState(parentItem, parentsChildren)
                    }
                });  
            }
        }
    }
}

export const getDeliveryCells = (row: PriceSettings, cellSettings: CellSettings<PriceSettings>): TableCell[] => {
    return [
        {
            Name: cellSettings.Name?.name,
            Component: productPriceSettingDistCell
        },
        {
            Name: cellSettings.MinVolume?.name,
            Component: productPriceSettingMinVolumeCell
        },
        {
            Name: cellSettings.MaxVolume?.name,
            Component: productPriceSettingMaxVolumeCell
        },
        {
            Name: cellSettings.MinTerm?.name,
            Component: productPriceSettingMinTermCell
        },
        {
            Name: cellSettings.MaxTerm?.name,
            Component: productPriceSettingMaxTermCell 
        },
        {
            Name: cellSettings.Price?.name,
            Component: productPriceSettingPriceCell
        },
        {
            Name: cellSettings.Price?.name,
            Component: productPriceSettingPriceCell
        },
        {
            Name: cellSettings.Discounts?.name,
            Component: productPriceSettingDiscountCell
        }
    ]
}

export const getPickupCells = (row: PriceSettings, cellSettings: CellSettings<PriceSettings>): TableCell[] => {
    return [
        {
            Name: cellSettings.Name?.name,
            Component: productPriceSettingDistCell
        },
        {
            Name: cellSettings.MinVolume?.name,
            Component: productPriceSettingMinVolumeCell
        },
        
        {
            Name: cellSettings.MaxVolume?.name,
            Component: productPriceSettingMaxVolumeCell
        },
        {
            Name: cellSettings.MinTerm?.name,
            Component: productPriceSettingMinTermCell
        },
        {
            Name: cellSettings.MaxTerm?.name,
            Component: productPriceSettingMaxTermCell 
        },
        {
            Name: cellSettings.Price?.name,
            Component: productPriceSettingPriceCell
        },
        {
            Name: cellSettings.Discounts?.name,
            Component: productPriceSettingDiscountCell
        }
    ]
}